import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import Armature from '../../../Prototype/Armature';
import {
    AwaitIterators,
    ConcatIterators,
    PlayAnimation,
} from '../AnimationHelper';
import UIItem from '../../../Prototype/UI/UIItem';
import { DragonbonesDefault } from './DragonbonesDefault';

export class ShowCropUnlockShare extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const blankImage = UIItem.createImage({ cacheKey: 'blank' });
        const armature = GameObject.Instantiate(Armature, {
            dragonbonesName: 'unlock_share',
            armatureName: 'Armature',
            playOnStart: false,
            playTimes: 1,
        });
        blankImage.addChild(armature);
        gameObject.addChild(blankImage);

        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );
        const renderable: Renderable = gameObject.getComponent(Renderable);
        renderable.visible = true;
        renderable.alpha = 0;

        const alphaTween: Tween = this.getTween(renderable).to({ alpha: 1 }, 200);

        element.anchors = [0, 0, 1, 1];

        yield* AwaitIterators([
            PlayAnimation(
                new DragonbonesDefault(armature, {
                    playTimes: 1,
                })
            ),
            this.startTween(alphaTween),
        ]);
    }
}
